<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TweenMax as Tween, Power1 } from 'gsap'
import find from 'lodash/find'
import TransitionWrapper from '@/layout/wrappers/transition-wrapper'
import Dots from '@/components/dots'
import BaseButton from '@/components/base-button'
import IMask from 'imask'

export default {

  name: 'FeedbackForm',

  components: {
    BaseButton,
    TransitionWrapper,
    Dots
  },

  data () {
    return {
      visible: false,
      sending: false,
      invalid: false,
      failed: false,
      currentStep: 1
    }
  },

  computed: {
    widget () {
      const contactsPage = this.$store.state.pages.landings.contacts
      const widget = contactsPage.contacts

      return widget
    },

    action () {
      return this.widget.action
    },

    steps () {
      return this.widget.steps
    },

    formData () {
      return this.$store.state.form.formData
    }
  },

  created () {
    this.$store.commit('form/reset')
    this.$root.$on('keypress', this.onKeypress)
  },

  beforeDestroy () {
    this.$root.$off()
  },

  methods: {
    onKeypress (event) {
      if (event.keyCode === 27) {
        this.$store.dispatch('closePopup')
      }
    },

    update (event) {
      this.invalid = false

      const input = event.target
      const key = input.getAttribute('data-id')
      const value = input.value

      this.$store.commit('form/updateField', { key, value })

      this.validate()
    },

    enter (el, done) {
      setTimeout(() => {
        this.visible = true
        done()
      }, 500)
    },

    closeThankYou() {
      setTimeout(() => {
        this.$store.dispatch('closePopup')
      }, 10000);
    },

    stepEnter (el, done) {
      const primary = el.querySelector('[data-primary]')
      const secondary = el.querySelector('[data-secondary]')

      window.secondary = secondary;
      Tween.staggerFrom([primary, secondary], 2.5, {
        autoAlpha: 0,
        y: -40,
        ease: Power1.easeOut,
        onStart: () => {
          if (secondary.tagName.match(/input/i)) {
            secondary.focus()

            const key = secondary.getAttribute('data-id')

            if (this.formData.hasOwnProperty(key)) {
              secondary.value = this.formData[key]
            }

            this.update({ target: secondary })
          }
        },
        onComplete: () => {
          if (secondary.tagName.match(/input/i)) secondary.focus()
        }
      }, 0.05, done)

      const phoneInput = document.querySelector('input[type="phone"]')

      if (phoneInput) {
          new IMask(phoneInput, {
            mask: '+{38} 000 000 00 00',
            lazy: false,
            placeholderChar: ' ',
            commit: (value, masked) => {
              value
            }
          })
      }

      if(this.currentStep - 1 === this.steps.length) {
        this.closeThankYou()
      }
    },

    stepLeave (el, done) {
      const primary = el.querySelector('[data-primary]')
      const secondary = el.querySelector('[data-secondary]')

      Tween.staggerTo([primary, secondary], 0.5, {
        autoAlpha: 0,
        y: 40,
        ease: Power1.easeOut
      }, 0.05, done)
      done()
    },

    onBlur () {
      const input = this.$el.querySelector('.step__input')

      if (input && this.currentStep < this.steps.length) {
        input.focus()
      }
    },

    prevStep () {
      this.currentStep = Math.max(this.currentStep - 1, 1)
    },

    async nextStep () {
      if (!this.validate()) return

      if (this.currentStep !== this.steps.length) {
        this.currentStep = Math.min(this.currentStep + 1, this.steps.length + 1)
        return
      }

      try {
        this.sending = true
        this.currentStep = Math.min(this.currentStep + 1, this.steps.length + 1)

        const result = await this.$store.dispatch('form/send', 'get')

        if (!result) {
          this.failed = true
        }

        this.sending = false
      } catch (e) {
        this.failed = true
        this.sending = false
      }
    },

    validate () {
      const input = this.$refs.input[0];
      const type = input.getAttribute('type');
      const value = input.value;
      // const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i
//      const emailPattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i
      const emailPattern = /^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+[\.]+[a-zA-Z0-9]+(?:\.[a-zA-Z0-9-]+)*$/i
      // const phonePattern = /^[0-9+\-() ]+$/i
      const phonePattern = value.replace(/\s/g, '');

      if (!input) return true;

      if (value.length <= 0) {
        this.invalid = true;
        return false
      }

      if (type === 'email' && !emailPattern.test(value)) {
        this.invalid = true;
        return false
      }

      if (type === 'phone' && phonePattern.length < 13) {
        this.invalid = true;
        return false
      }

      return true
    }
  }
}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

form.form(ref="form", @submit.prevent="nextStep" novalidate)
  transition-wrapper(:appear="true")
    dots.form__navigation(v-if="visible && currentStep !== steps.length + 1", :items="steps", :current="currentStep - 1")

  .form__content
    transition(appear @enter="stepEnter" @leave="stepLeave" mode="out-in")

      template(v-if="currentStep <= steps.length")
        .step(v-for="step, index in steps", :key="index", v-if="visible && index + 1 === currentStep")
          .step__heading(data-primary v-html="step.question")
          input.step__input(
            data-secondary
            autocomplete='off',
            autocorrect="off",
            ref="input",
            :name="step.name",
            :type="step.type",
            :data-id="step.name",
            :disabled="sending",
            @blur="onBlur",
            @input="update")
          transition(name="fade")
            //- .step__error(v-if="invalid") {{ $t('invalid-field') }}

      template(v-else-if="sending")
        .step(key="loader")
          .loader(data-primary)
          .loader__label(data-secondary) {{ $t('form-sending') }}

      template(v-else)
        .step(key="thank-you")
          .step__heading.is-large(data-primary) {{ failed ? $t('form-fail-title') : $t('form-thank-title') }}
          .step__subheading(data-secondary) {{ failed ? $t('form-fail-subtitle') : $t('form-thank-subtitle') }}
          base-button.step__button(data-secondary :url="'/' ", :label="$t('go-to-homepage')" ref="button" @click.native="$store.commit('closePopup')")

  transition(appear name="fade")
    .form__controls.controls(v-if="visible && currentStep <= steps.length")
      button.controls-button(type="button", :disabled="currentStep <= 1", @click="prevStep")
        .controls-button__content
          img(src="../../assets/arrow-prev.svg" alt="arrow prev")
          span.controls-button__label {{ $t('form-prev-step') }}

      .controls-sep

      button.controls-button(type="button", :disabled="currentStep >= steps.length + 1 || invalid", @click="nextStep")
        .controls-button__content
          span.controls-button__label {{ $t('form-next-step') }}
          img(src="../../assets/arrow-next.svg" alt="arrow next")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.form
  position relative
  width 100%
  height 100%

  &__navigation
    position absolute
    top 40px
    left 0
    right 0
    margin 0 auto

    +mobile()
      top 60px

  &__content
    width 100%
    height 100%
    display flex
    justify-content center
    align-items center
    color white

    +mobile()
      padding 0 15px

  &__controls
    position absolute
    left 0
    right 0
    bottom 70px

.step
  position relative
  max-width 780px
  width 100%
  display flex
  flex-direction column
  align-items center

  &__heading
    font-weight 400
    font-size 36px
    line-height 42px
    user-select none
    text-align center

    &.is-large
      font-size 56px
      line-height 57px

    +mobile()
      &.is-large
        font-size 26px
        line-height 34px

  &__subheading
    margin-top 23px
    font-weight 400
    font-size 26px
    line-height 34px
    text-align center
    user-select none

    +mobile()
      font-size 13px
      line-height 20px

  &__input
    width 100%
    margin-top 85px
    height 56px
    font-weight 500
    text-align center
    font-size 17px
    line-height 25px
    border 0
    outline 0
    color inherit
    background none

    +mobile()
      margin-top 56px
      font-size 13px
      line-height 20px

    &:disabled
      opacity 0.5

  &__error
    position absolute
    left 0
    right 0
    bottom -40px
    margin 0 auto
    text-align center
    font-weight 500
    font-size 16px
    line-height 23px
    white-space nowrap
    color #ee6b4c

  &__button
    margin 50px auto 0

    & >>> .label
      color #fff

.controls
  display flex
  justify-content center
  align-items center
  user-select none

.controls-button
  cursor pointer
  img
    transition transform .33s ease-in-out

  &:disabled
    opacity 0.5
    cursor default

  +desktop()
    &:hover:not(:disabled)
      img
        transition transform .33s ease-in-out
        &:first-child
          transform translateX(-5px)

        &:last-child
          transform translateX(5px)

  &__content
    display flex
    align-items center

  &__label
    padding 0 15px
    font-weight 500
    font-size 16px
    line-height 23px
    color white

.controls-sep
  width 2px
  height 34px
  background-color white
  margin 0 30px
  transform skew(-30deg)

.loader
  display block
  width 50px
  height 50px
  border 5px solid transparent
  border-top-color orange
  border-bottom-color orange
  border-radius 50%
  animation spinner .8s ease-in-out infinite

  &__label
    margin-top 30px
    font-weight 400
    font-size 24px
    line-height 34px
    text-align center
    user-select none

    +mobile()
      margin-top 24px
      font-size 14px
      line-height 20px

// ===========================================
// Animation
// ===========================================

.fade-enter
.fade-leave-to
  opacity 0
  visibility hidden

.fade-enter-active
.fade-leave-active
  transition opacity .3s, visibility .3s

@keyframes spinner
  from
    transform rotate(0deg)
  to
    transform rotate(360deg)

// ===========================================
// IE
// ===========================================
input::-ms-clear
  display: none;
  width : 0;
  height: 0;
input::-ms-reveal
  display: none;
  width : 0;
  height: 0;

</style>



// WEBPACK FOOTER //
// feedback-form.vue?388b5756